// extracted by mini-css-extract-plugin
export default {"Caption":"Caption_Caption__HNIqT","CaptionRunning":"Caption_CaptionRunning__2Q4ZC","CaptionBreak":"Caption_CaptionBreak__ZnD53","CaptionPause":"Caption_CaptionPause__TauRc"};